// src/redux/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit';
import userSlice from './slices/userSlice';
import dashboardSlice from './slices/dashboardSlice';
import bannerSlice from './slices/dashboardSlice';
import orderSlice from './slices/orderSlice';
import shipmentSlice from './slices/shipmentSlice';
import settingSlice from './slices/settingSlice';
import appSlice from './slices/appSlice';
import pickupAddressSlice from './slices/pickupAddressSlice';
import walletTransactionSlice from './slices/walletTransactionSlice';
import shippingChargesSlice from './slices/shippingChargesSlice';
import weightDisputeSlice from './slices/weightDisputeSlice';
import employeesLoginSlice from './slices/employeesLoginSlice';
import invoiceSlice from './slices/invoiceSlice';
import channelSlice from "./slices/channelSlice";
import escalationSlice from "./slices/escalationSlice";
import ndrSlice from "./slices/ndrSlice";
import codRemittanceSlice from './slices/codRemittanceSlice';
import creditNoteSlice from './slices/creditNoteSlice';
import notificationSlice from './slices/notificationSlice';
import walletSlice from './slices/walletSlice';

import { logoutUser } from './slices/userSlice';

const appReducer = combineReducers({
    user: userSlice,
    dashboard: dashboardSlice,
    banner: bannerSlice,
    order: orderSlice,
    shipment: shipmentSlice,
    setting: settingSlice,
    pickupAddress: pickupAddressSlice,
    app: appSlice,
    walletTransaction: walletTransactionSlice,
    shippingCharges: shippingChargesSlice,
    weightDispute: weightDisputeSlice,
    employeesLogin: employeesLoginSlice,
    invoice: invoiceSlice,
    channel: channelSlice,
    escalation: escalationSlice,
    ndr: ndrSlice,
    codRemittance: codRemittanceSlice,
    creditNote: creditNoteSlice,
    notification: notificationSlice,
    wallet: walletSlice
});

const rootReducer = (state, action) => {
    if (action.type === logoutUser.fulfilled.type) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;